module.exports = __webpack_public_path__ + "static/media/emailSvg.1f0151ef.svg";